import React from 'react';

// Today-screen loading placeholder — six shimmer cards that mirror the question-
// card shape, shown instead of a centered "Loading today's six…" spinner so a
// cold load reads as "content arriving", not "stalled". Paired with the public
// /api/today fast-paint, the real cards usually replace these within a beat.
// (The masthead — "Predict Six / Today's Questions" — is rendered by AppShell,
// so it's already on screen above this.)
export default function TodaySkeleton() {
  return (
    <main className="ps-page" aria-busy="true" aria-label="Loading today’s six">
      <style>{shimmerCss}</style>
      {Array.from({ length: 6 }).map((_, i) => (
        <div className="ps-card" style={cardStyle} key={i}>
          <div style={{ ...sk, ...imageStyle }} />
          <div style={rowStyle}>
            <div style={{ ...sk, width: 84, height: 22, borderRadius: 999 }} />
            <div style={{ ...sk, width: 58, height: 22, borderRadius: 999 }} />
          </div>
          <div style={{ ...sk, height: 16, width: '94%', marginBottom: 8 }} />
          <div style={{ ...sk, height: 16, width: '68%', marginBottom: 16 }} />
          <div style={{ display: 'flex', gap: 10 }}>
            <div style={{ ...sk, flex: 1, height: 48 }} />
            <div style={{ ...sk, flex: 1, height: 48 }} />
          </div>
        </div>
      ))}
    </main>
  );
}

const cardStyle = { marginBottom: 14 };
const rowStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 10,
};
const sk = {
  background:
    'linear-gradient(100deg, var(--surface) 30%, var(--border) 50%, var(--surface) 70%)',
  backgroundSize: '200% 100%',
  animation: 'psSkeleton 1.3s ease-in-out infinite',
  borderRadius: 'var(--radius-sm)',
};
const imageStyle = { width: '100%', aspectRatio: '4 / 3', marginBottom: 12 };
const shimmerCss =
  '@keyframes psSkeleton { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }';
